import { QuillOperation } from "../../../../interfaces/quill";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

type BioViewerProps = { bio: QuillOperation[] };

export const BioViewer = ({ bio }: BioViewerProps) => {
  const converter = new QuillDeltaToHtmlConverter(bio, {
    multiLineParagraph: true,
  });
  const html = converter.convert();

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};
